import React, { useState } from 'react';
import styled from 'styled-components';

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Button onClick={handleCopy} $copied={copied}>
      {copied ? 'Copied!' : 'Copy'}
    </Button>
  );
};

const Button = styled.button`
  font-family: var(--font-mono);
  font-size: 0.7rem;
  padding: 0.25rem 0.625rem;
  border: 1px solid ${props => props.$copied ? 'var(--accent)' : 'var(--border)'};
  border-radius: 3px;
  background: var(--bg-surface-2);
  color: ${props => props.$copied ? 'var(--accent)' : 'var(--text-muted)'};
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;

  &:hover {
    color: var(--text-primary);
    border-color: var(--text-muted);
  }
`;

export default CopyButton;
